import { Col, Row } from 'antd';
import React, { useState } from 'react';
import Title from 'antd/es/typography/Title';
import { MapData } from './Types/types';
import { defaultMapData, MapDataContext } from './hooks/useMapTaxiBusinessData';
import MapContent from './Components/MapContent';

const MapTaxiBusinessView = () => {
    const [mapData, setMapData] = useState<MapData>(defaultMapData);

    return (
        <>
            <Row style={{ paddingBottom: 10, paddingTop: 20 }}>
                <Col span={12}>
                    <Title level={3}>Map Taxi/Rider</Title>
                </Col>
            </Row>
            <div style={{ flex: '1 1 auto' }}>
                <MapDataContext.Provider value={{ mapData, setMapData }}>
                    <MapContent />
                </MapDataContext.Provider>
            </div>
        </>
    );
};
export default MapTaxiBusinessView;
